import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { HomeService } from '../../services/home/home.service';
import { PAGES } from '../../constants/route.constants';
import { ToasterService } from '../../components/toast/toaster.service';
import { debounceTime, filter, Subject } from 'rxjs';
import { models, IReportEmbedConfiguration } from 'powerbi-client';
import { PowerBIReportEmbedComponent } from 'powerbi-client-angular';
import { EventHandler } from 'powerbi-client-angular/components/powerbi-embed/powerbi-embed.component';
import { ReportNames } from 'src/app/enums/home.enum';

@Component({
  selector: 'app-powerbi-dashboard',
  templateUrl: './powerbi.dashboard.component.html',
  styleUrls: ['./powerbi.dashboard.component.scss'],
})
export class PowerBiDashboardComponent implements OnInit, OnDestroy {
  public breadcrumbs = [{ label: 'HOME', url: `/${PAGES.HOME}` }];   
  loading: boolean = false;
  embedConfigDeal: IReportEmbedConfiguration;
  private destroy$: Subject<void> = new Subject<void>();

  public width: number = 55;
  public height: number = 55;
  public persona: string = '';
  engagementId:any = "";
  reportName: keyof typeof ReportNames | null | string= "DEAL_TRACKING";
  model: any;
eventHandlers: Map<string,EventHandler|null>|undefined = new Map([
  ['loaded', () => console.log('Report loaded')],
  ['rendered', () => console.log('Report rendered')],
  ['error', (event:  any) => console.log(event.detail)]
]);;
  constructor(
    private router: Router,
    private homeServiceRef: HomeService,
    private toasterServiceRef: ToasterService,
    private route: ActivatedRoute,
  ) {
    this.embedConfigDeal = {
      type: 'report', 
      id: '',
      embedUrl:undefined,
      accessToken: undefined,
      // embedUrl: 'https://app.powerbi.com/reportEmbed?reportId=6c6cf174-297b-4c56-ba5e-31c462d96093',
      tokenType: models.TokenType.Embed,    
      settings: {
        panes: {
            filters: {
                expanded: false,
                visible: false
            },
        },          
        layoutType: models.LayoutType.Custom,
        customLayout: {
          displayOption: models.DisplayOption.FitToWidth
        },
        background: models.BackgroundType.Transparent,
      }
    };
  }
  getReportId(){
    if(this.reportName)
      return ReportNames[this.reportName as keyof typeof ReportNames];
    else
      return '';
  }

  ngOnInit(): void {    
    // const url = 'https://app.powerbi.com/groups/72dfe195-cee3-476a-ac8d-f87b94a82d8d/reports/6c6cf174-297b-4c56-ba5e-31c462d96093/GenerateToken'
    
    this.model = models;
    this.homeServiceRef.persona$.subscribe((persona) => {
      this.persona = persona;
    });
    this.updateReport();
    this.router.events
        .pipe(filter(event => event instanceof NavigationEnd), debounceTime(500))
        .subscribe(() => {      
          this.updateReport();
        });
    if (this.engagementId) {
      this.homeServiceRef.setEngagementId(this.engagementId);
      
    }
  }
  updateReport(){
    this.engagementId = this.route.snapshot.paramMap.get('id');
    this.reportName = this.route.snapshot.paramMap.get('name');
    const reportId = this.getReportId();
    console.log('Report ID:', reportId);
    if(reportId){
      const reqObj = {
        "clientId": this.engagementId,
        "workspaceId": "72dfe195-cee3-476a-ac8d-f87b94a82d8d",
        "reportId": this.getReportId()
      };
      this.homeServiceRef.getTokenForPowerBIDashboard(reqObj.clientId, reqObj.workspaceId, reqObj.reportId).subscribe((data) => {
        this.embedConfigDeal = {...this.embedConfigDeal, id: this.getReportId(), accessToken: data.token, embedUrl: data.embedUrl};
        setTimeout(() => {
          const reportElement = document.querySelector('.reportClass');
          const iframe = document.querySelector('iframe');
          if (reportElement) {
            (reportElement as HTMLElement).style.height = '100%';
          }
          if (iframe) {
            (iframe as HTMLElement).style.border = '0 none';
          }
        }, 2000);
      });
      setTimeout(() => {
        this.loading = false;
      }, 2000);
    }
  }
  ngAfterViewInit(): void {
    // this.loading = false;
  }
  onLoaded(event: any): void {
    console.log('Power BI report loaded', event);
  }

  onError(event: any): void {
    console.error('Power BI report error', event);
  }
  goto(linkName:any){
    if(this.engagementId != "")
    {
      if(linkName == "Governance Meetings"){
        this.router.navigate([`/governance-meetings`, {id:this.engagementId}]);
      }
      if(linkName == "Innovation Productivity"){
        this.router.navigate([`/innovation-productivity`, this.engagementId]);
      }
      if(linkName == "Transition Page"){
        this.router.navigate([`/transition-page`, {id:this.engagementId}]);
      }
    }
  
  }
  ngOnDestroy(): void {
    this.homeServiceRef.setEngagementId('');
    this.destroy$.next();
    this.destroy$.complete();
  }

}
